<script>
  // import axios from "axios"
  import { push } from "svelte-spa-router"
  // import ApplicationState from "../../../../Stores/applicationStates"
  import { releaseDocumentId } from "../script"
  import SinglePublish, { updateSinglePublish } from "../Stores/singlePublishStore"
  import DocDeletemodel from "./DocDeletemodel.svelte"
  import notify from "../../../../Script/notify"
  import { loadQR } from "../../BulkUpload/Script/bulkUpload"
  import ApplicationState from "../../../../Stores/applicationStates"
  import { deleteRequest } from "../../../../Script/apiMethods"

  /**
   * @type {String} - Export a variable to control the loading screen massage
   */
  export let msg

  /**
   * @type {Boolean} -  Export a variable to control the state of an API call button
   */
  export let apiCallBtnDisable = false

  /**
   * @type {Boolean} - used to show or hide the release model
   */
  let releaseModel = false

  /**
   * @description - Navigates the user back within a multi-step document publishing process based on the current URL hash. If the current step is recognized, this function redirects the user to the previous step.
   */
  const goBack = () => {
    // Check the current URL hash
    if (window.location.hash === `#/publish/single/upload_document?documentId=${$SinglePublish.documentId}`) {
      // If the hash matches the upload_document step, navigate to choose_template step
      push(`/publish/single?documentId=${$SinglePublish.documentId}`)
    }
    // else if (window.location.hash === `#/publish/single/preview?documentId=${$SinglePublish.documentId}`) {
    //   // If the hash matches the preview step, navigate to metadata step
    //   push(`/publish/single/metadata?documentId=${$SinglePublish.documentId}`)
    // }
    else if (window.location.hash === `#/publish/single/metadata?documentId=${$SinglePublish.documentId}`) {
      $SinglePublish.documentTemplateId = ""
      updateSinglePublish($SinglePublish)
      // If the hash matches the preview step, navigate to metadata step
      push(`/publish/single/choose_template?documentId=${$SinglePublish.documentId}`)
    }
  }

  /**
   * @type {releaseNotify} - document releasing notification
   */
  let releaseErrorNotify = {
    close() {},
  }

  /**
   * @description Releases a document by making an API call to release its ID.  Handles success and error cases, and updates UI accordingly.
   * @async
   * @function
   * @returns {void}
   */
  const releaseDocID = async () => {
    console.log("hits")

    // Close any existing error notification
    releaseErrorNotify.close()
    try {
      // Disable the API call button and reset the releaseModel flag
      apiCallBtnDisable = true
      releaseModel = false
      let force = $SinglePublish.docketId ? true : false

      if (force) {
        msg = "Releasing docket"
        // Release Docket
        await deleteRequest(`/api/pdf-signing/v2/docket/${$SinglePublish.docketId}?force=true`, {
          headers: {
            "msign-org-token": $ApplicationState.msignToken,
          },
        })
      }

      msg = "Releasing document"
      await releaseDocumentId($SinglePublish.documentId, force)

      // Clear local storage and reset the $SinglePublish object
      localStorage.removeItem("P2BSinglePublish")
      $SinglePublish = {}

      // Show a success notification
      notify.success("Document <strong>released</strong> Successfully")

      // Navigate back to the initial publishing page
      push("/publish/single")
    } catch (error) {
      console.error(error)
      // Display an error notification
      const info = "PAGE: Single Publish\nEVENT: While releasing document"
      releaseErrorNotify = notify.danger(error, info)
    } finally {
      // Reset flags and re-enable the API call button
      releaseModel = false
      apiCallBtnDisable = false

      // Update the UI with the latest $SinglePublish data
      updateSinglePublish($SinglePublish)
    }
  }

  const handleQRDownload = async () => {
    try {
      let qrCode = await loadQR($SinglePublish.QRCode)

      let a = document.createElement("a")
      a.href = qrCode
      a.download = $SinglePublish.documentId
      a.click()
    } catch (error) {
      console.error(error)
    }
  }
</script>

<div class="mb-3 flex items-end justify-between">
  <div class="space-y-1">
    {#if window.location.hash.split("?")[0] == `#/publish/single/metadata`}
      <button on:click={() => goBack()} type="button" class="w-16 cursor-pointer select-none text-base font-medium text-gray-200 hover:text-blue-600 focus-visible:text-blue-600 focus-visible:outline-none active:text-blue-500" style="text-decoration: none;">
        <span>
          <i class="fa-solid fa-reply" />
          <span>&nbsp;Back&nbsp;</span>
        </span>
      </button>
    {/if}
    <h1 class="select-none text-xl font-bold text-black dark:text-white {window.location.hash.split('?')[0] == `#/publish/single/upload_document` || window.location.hash.split('?')[0] == `#/publish/single/choose_template` || window.location.hash.split('?')[0] == `#/publish/single/metadata` || window.location.hash.split('?')[0] == `#/publish/single/preview` ? 'mt-7' : 'mt-0'} ">
      {#if window.location.hash.split("?")[0] == `#/publish/single/choose_template`}
        Choose Document Template
      {:else if window.location.hash.split("?")[0] == `#/publish/single/upload_document`}
        {!$SinglePublish.uri ? "Upload Document" : "Preview Document"}
      {:else if window.location.hash.split("?")[0] == `#/publish/single/metadata`}
        Edit Document Metadata
      {:else if window.location.hash.split("?")[0] == `#/publish/single/preview`}
        Publish Document
      {/if}
    </h1>
  </div>
  <div class="flex items-center gap-3">
    {#if window.location.hash.split("?")[0] == `#/publish/single/upload_document` && !$SinglePublish.uri}
      <button on:click={handleQRDownload} type="button" tabindex="0" data-tooltip="Download QR Code" tooltip-position="top" class="flex h-9 min-w-[36px] cursor-pointer items-center justify-center rounded-full border border-[#a0a1a580] bg-white px-2 text-sm font-medium text-gray-900 hover:bg-blue-600 hover:text-white focus:outline-none focus-visible:bg-blue-600 focus-visible:text-white focus-visible:outline-none active:bg-blue-500 disabled:cursor-not-allowed dark:bg-black dark:text-white dark:hover:bg-blue-600">
        <i class="fa-solid fa-qrcode" />
      </button>
      <!-- <a href={$SinglePublish.QRCode} download="QRCode" type="button" tabindex="0" data-tooltip="Download QR Code" tooltip-position="top" class="flex h-9 min-w-[36px] cursor-pointer items-center justify-center rounded-full border border-[#a0a1a580] bg-white px-2 text-sm font-medium text-gray-900 hover:bg-blue-600 hover:text-white focus:outline-none focus-visible:bg-blue-600 focus-visible:text-white focus-visible:outline-none active:bg-blue-500 disabled:cursor-not-allowed dark:bg-black dark:text-white dark:hover:bg-blue-600">
        <i class="fa-solid fa-qrcode" />
      </a> -->
    {/if}
    <button disabled={apiCallBtnDisable} on:click={() => (releaseModel = !releaseModel)} type="button" tabindex="0" data-tooltip="Release document" tooltip-position="left" class="flex h-9 min-w-[36px] cursor-pointer items-center justify-center rounded-full border border-[#a0a1a580] bg-white px-2 text-sm font-medium text-gray-900 hover:bg-red-600 hover:text-white focus:outline-none focus-visible:bg-red-600 focus-visible:text-white focus-visible:outline-none active:bg-red-500 disabled:cursor-not-allowed dark:bg-black dark:text-white dark:hover:bg-red-600">
      <i class="fa-solid fa-trash-can" />
    </button>
  </div>
</div>

<DocDeletemodel isDocketLinked={$SinglePublish.docketId ? true : false} on:click={releaseDocID} bind:releaseModel />
